/** Save a Blob as a file: a temporary link, clicked, then cleaned up. */
export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Let the browser start the download before the URL goes away.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

/** A Blob's text (Blob.text where available, else FileReader). */
export const readBlobText = (blob) => {
  if (blob && typeof blob.text === 'function') return blob.text();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
};

export default downloadBlob;
